module.exports = __webpack_public_path__ + "img/lisensi.aa70809d.png";